const BookIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={"1em"}
        height={"1em"}
        viewBox="0 0 15 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.25 2.75C7.25 2.21957 7.46071 1.71086 7.83579 1.33579C8.21086 0.960714 8.71957 0.75 9.25 0.75H13.25C13.3826 0.75 13.5098 0.802679 13.6036 0.896447C13.6973 0.990215 13.75 1.11739 13.75 1.25V9.25C13.75 9.38261 13.6973 9.50979 13.6036 9.60355C13.5098 9.69732 13.3826 9.75 13.25 9.75H9.25C8.71957 9.75 8.21086 9.96071 7.83579 10.3358C7.46071 10.7109 7.25 11.2196 7.25 11.75M7.25 2.75V11.75M7.25 2.75C7.25 2.21957 7.03929 1.71086 6.66421 1.33579C6.28914 0.960714 5.78043 0.75 5.25 0.75H1.25C1.11739 0.75 0.990215 0.802679 0.896447 0.896447C0.802678 0.990215 0.75 1.11739 0.75 1.25V9.25C0.75 9.38261 0.802678 9.50979 0.896447 9.60355C0.990215 9.69732 1.11739 9.75 1.25 9.75H5.25C5.78043 9.75 6.28914 9.96071 6.66421 10.3358C7.03929 10.7109 7.25 11.2196 7.25 11.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default BookIcon;
